import Service, { getCallApiFunction } from '../service'
import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsTypes = {
  roomId: string
}

class FetchPlaybackInfoApi extends Service {
  constructor(params: ParamsTypes) {
    super()
    this.name = 'FETCH_PLAYBACK_INFO'

    this.config = {
      url: `/v1/room/playback`,
      method: 'GET',
      params,
    }

    this.denormalizer = denormalizer
  }
}

export const fetchPlaybackInfo = (params: ParamsTypes) => getCallApiFunction(new FetchPlaybackInfoApi(params))
